<template>
  <div class="details-component" style="margin-top: 44px">
    <div class="details-component__header">
      <h1>{{ $t('kiosk_permits.table_title') }}</h1>
    </div>
    <div class="filters">
      <div class="filter-type">
        <span class="label">{{ $t('kiosk_permits.valid_from') }}: </span>
        <el-date-picker
          v-model="filters.startDate"
          format="dd.MM.yyyy"
          type="date"
          name="startDate"
          :default-time="defaultTime"
          @change="saveData('startDate', $event)"
        />
      </div>
      <div class="filter-type">
        <span class="label">{{ $t('kiosk_permits.valid_to') }}: </span>
        <el-date-picker
          v-model="filters.endDate"
          format="dd.MM.yyyy"
          type="date"
          name="endDate"
          :default-time="defaultTime"
          @change="saveData('endDate', $event)"
        />
      </div>
      <div class="filter-type">
        <span class="label">{{ $t('kiosk_permits.vehicle_nr') }}:</span>
        <input
          v-model="filters.vehicle_nr"
          type="text"
          class="el-input__inner vehicle-nr"
          name="vehicle_nr"
          @keyup="saveData('vehicle_nr', $event.target.value)"
        >
      </div>
      <div class="filter-type">
        <span class="label">{{ $t('kiosk_permits.id_code') }}:</span>
        <input
          v-model="filters.id_code"
          type="text"
          class="el-input__inner vehicle-nr"
          name="id_code"
          @keyup="saveData('id_code', $event.target.value)"
        >
      </div>
      <div class="filter-type">
        <span class="label">{{ $t('kiosk_permits.permit_status') }}:</span>
        <el-select
          name="permit_status"
          v-model="filters.permit_status"
          @change="saveData('permit_status', $event)"
        >
          <el-option :label="$t('kiosk_permits.all')" value="all"></el-option>
          <el-option :label="$t('kiosk_permits.active')" value="active"></el-option>
          <el-option :label="$t('kiosk_permits.expired')" value="expired"></el-option>
        </el-select>
      </div>
      <div class="filter-type">
        <span class="label">{{ $t('kiosk_permits.payment_status') }}:</span>
        <el-select
          name="state"
          v-model="filters.state"
          @change="saveData('state', $event)"
        >
          <el-option :label="$t('kiosk_permits.all')" value="all"></el-option>
          <el-option :label="$t('kiosk_permits.status_completed')" value="completed"></el-option>
          <el-option :label="$t('kiosk_permits.status_not_completed')" value="not_completed"></el-option>
        </el-select>
      </div>
      <div class="filter-type" style="margin-top: 15px">
        <button
          type="submit"
          class="btn btn--secondary"
          style="height: 40px"
          @click="getPermitList"
        >
          {{ $t('kiosk_permits.find_permits') }}
        </button>
      </div>
      <div class="filter-type" style="margin-top: 15px">
        <button
          type="submit"
          class="btn btn--secondary--red"
          style="height: 40px"
          @click="permitsExport"
        >
          {{ $t('kiosk_permits.export') }}
        </button>
      </div>

    </div>
    <PermitsList v-if="permits && !isLoading" :permits="permits"/>
    <div v-else class="loader-bubbles"></div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {apiService} from "./api/services";
import PermitsList from "./ui/PermitsList";
import {configData} from "../ticket-types/mixins/configData"
import moment from "moment/moment";
import "./styles.scss"


export default {
  components: {
    PermitsList
  },
  mixins: [apiService, configData],
  props: ['kioskId'],
  created() {
    this.setDefaultDates()
    this.getPermitList()
  },
  computed: {
    ...mapGetters({
      permits: 'kiosks/permits/permits',
      filters: 'kiosks/permits/filters',
      isLoading: 'kiosks/permits/isLoading'
    }),
    defaultTime() {
      return moment().set('second', 0).format('HH:mm');
    },
  },
  data() {
    return {
      dateFormat: "yyyy-MM-DD",
      localLang: localStorage.getItem('locale')
    }
  },
  methods: {
    saveData(varName, data) {
      this.$store.dispatch('kiosks/permits/storeData', {
        varName: varName,
        value: varName.substr(-4) === 'Date' ? moment(data).format(this.dateFormat) : data
      })
    },
    setDefaultDates() {
      this.$store.dispatch('kiosks/permits/setFilterDates', {
        startDate: moment().days("-365").format(this.dateFormat),
        endDate: moment().days("+180").format(this.dateFormat)
      })
    },
    getPermitList() {
      this.$store.dispatch('kiosks/permits/setLoading', true)
      this.$store.dispatch('kiosks/permits/clear')
      this.getList(this.kioskId, this.filters)
        .then(response => {
          Object.values(response.data).forEach(item => {
            let data = {
              permit_nr: item.order_number,
              ticket_type: item.kiosk_permit_type.name[this.localLang] !== undefined
                ? item.kiosk_permit_type.name[this.localLang]
                : item.kiosk_permit_type.name[this.DEF_LANG],
              vehicle_nr: item.vehicle.vehicle_reg,
              id_code:item.id_code,
              valid_from: item.purchased_at,
              valid_to: item.expires_at,
              permit_status: item.active ? 'Active' : 'Expired',
              payment_status: item.transaction.state,
              total_sum: item.transaction.amount,
              receipt_download: item.transaction.has_receipt,
              download_link: item.transaction.has_receipt
                ? `${process.env.BACKEND_API_URL}v2/export/${item.id}/receipt?token=${localStorage.getItem('id_token')}`
                : '',
              client_receipt_download: item.transaction.has_client_receipt,
              client_receipt_link: item.transaction.has_client_receipt
                ? `${process.env.BACKEND_API_URL}v2/export/${item.id}/client-receipt?token=${localStorage.getItem('id_token')}`
                : ''
            }
            this.$store.dispatch('kiosks/permits/setToList', data)
          })
          this.$store.dispatch('kiosks/permits/setLoading', false)
        }).catch((response) => {
        console.log('error', response)
        this.$store.dispatch('kiosks/permits/setLoading', false)
      })
    },
    permitsExport() {
      window.open(
        `${process.env.BACKEND_API_URL}v2/export/${this.kioskId}/kiosk-permits` +
        `?token=${localStorage.getItem('id_token')}` +
        `&startDate=${this.filters.startDate}` +
        `&endDate=${this.filters.endDate}`
      )
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../../../styles/spinner';

</style>



// WEBPACK FOOTER //
// src/components/tenants/kiosk-permits/index.vue